import { render, staticRenderFns } from "./JdsTextArea.two.vue?vue&type=template&id=aadecd9a"
import script from "./JdsTextArea.two.vue?vue&type=script&lang=js"
export * from "./JdsTextArea.two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports